Vue.component("UIComponentRendere", {
    name: "UI-Layer",
    mixins: [ComponentRenderMixin]
})